<template>
  <div class="dashboard" @click="checkAgent()">
    <div class="sharePage" v-if="!currentWechat">
      <img class="sharePic" src="http://cdn.hongbaoxd.com/images/cf745696dd9aadd50df8f938853da54f.png" alt="">
      <img class="sharePic" src="http://cdn.hongbaoxd.com/images/4cbc899b6778e9204e2719b41d59b79a.png" alt="" />
      <button>立刻加入</button>
      <div class="popup-open-safari" :class="{'show': openSafariShow}">
        <div class="popup-content">
          <div><img src="//cdn.hongbaoxd.com/images/f6d9e1485fbd33127df61a814930977a.png" alt=""></div>
        </div>
      </div>
    </div>

    <div v-else>
      <!--头部-->
      <div class="header-block">
        <div class="box-cont">
          <div>试玩应用</div>
          <img class="sharePic" src="//cdn.hongbaoxd.com/images/4338d4dba0fd8d003ec76d7eb652b363.png" alt="" width=156>
          <div>每天下午 5:00 试玩最多</div>
          <div>赚钱赚到手软</div>
        </div>

        <div class="separate-line"></div>
      </div>

      <!--中部-->
      <div class="middle-block">
        <div>
          <img class="sharePic" src="//cdn.hongbaoxd.com/images/f0fc7aa89c9962e26fb23fd5654944c4.png" alt="">
        </div>
        <InstallDialog ref="install" />
      </div>

      <!--尾部-->
      <div class="bottom-block">
        <div class="btn-middle shadow tryplay">开始试玩</div>
      </div>

    </div>
  </div>
</template>

<style lang='scss' scoped>
  @import '../../dashboard/header';
  @import '../../dashboard/block';

  .nav-btn {
    top: 26px !important;
  }
  .header-block {
    padding-top: 58px;
    /* padding-top: 110px; */
    color: #FFFFFF;

    .separate-line {
      border: 1px solid;
      width: 177px;
      margin: auto;
      position: relative;
      top: -50px;
    }

    .box-cont {
      text-align: center;

      > div {
        &:first-child{
          font-size: 28px;
        }

        &:nth-child(4){
          font-size: 14px;
        }

        &:last-child{
          font-size: 14px;
        }
      }
    }
  }

  .middle-block {
    img {
      width: 210px;
      margin: 58px 0 0 58px;
    }
  }

  .bottom-block {
    .tryplay {
      margin: auto;
      margin-top: 75px;
      color: #753219;
      background: #FFDD80;
      width: 182px;
      height: 48px;
      line-height: 48px;
    }
  }

  @media only screen and (device-height: 812px) {
    .nav-btn {
      top: 35px !important;
    }
    .header-block {
      padding-top: 62px;
      /* padding-top: 90px; */
    }
  }

// installAuth
  #auth{
      .nav-btn {
        top: 36px !important;
      }
      .header-block {
        /* padding-top: 50px; */
        padding-top: 86px;
      }
      @media only screen and (device-height: 812px) {
        .nav-btn {
          top: 45px !important;
        }
        .header-block {
          /* padding-top: 72px; */
          padding-top: 76px;
        }
      }
  }

  .dashboard {
    background-color: #3A4E92;
    padding-bottom: 20px;

    .bottom-logo {
      text-align: center;
      height: 18px;

      img {
        height: 18px;
      }
    }

    .popup-open-safari {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .75);
      z-index: 20;
      opacity: 0;
      transition: 0.3s opacity;

      &.show {
        z-index: 999;
        opacity: 1;
      }

      .popup-content {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 222px;
        height: 120px;

        img {
          width: 222px;
          height: 120px;
        }
      }
    }

    .sharePage{
      text-align: center;
      .sharePic{
        width: 100%;
        &:first-child{
          width: 53%;
          margin: 40px auto;
        }
      }
      button {
        width: 53%;
        border:none;
        padding: 10px;
        font-size: 20px;
        color: #3a3a3a;
        margin-top: 40px;
        border-radius: 40px;
        background-color: #fff;
      }
    }
  }
</style>

<script>
import { mapActions } from 'vuex'
import InstallDialog from './popups/InstallDialog'
import OpenSafariDialog from '@/components/OpenSafariDialog'
import { URI_ASSISTALIVE } from '@/store/modules/shoutu/type'
export default {
  name: 'ShouTu',
  components: {
    InstallDialog,
    OpenSafariDialog
  },
  props: {
    msg: String
  },
  computed: {
  },
  data () {
    return {
      currentWechat: false,
      openSafariShow: false,
      agent: window.navigator.userAgent.toLocaleLowerCase()
    }
  },
  created () {
    if (this.$route.path !== '/outland/') {
      this.currentWechat = true
    } else {
      if (this.isWeixin() || this.isQQ()) {
        this.currentWechat = false
      }
      if (this.isSafari()) {
        let host = location.host
        if (process.env.VUE_APP_HOST.indexOf(host)) {
          this.currentWechat = true
        } else {
          window.location.href = `http://${host}${location.pathname}${location.search}`
        }
      }
    }
  },

  mounted () {
    this.getAlive()
  },

  methods: {
    ...mapActions({
      getAlive: URI_ASSISTALIVE
    }),

    checkAgent () {
      if (this.$route.path === '/outland/') {
        if (this.openSafariShow) {
          this.openSafariShow = false
          return
        }

        if (this.isSafari()) {
          this.$refs.install.show()
        } else if (this.isWeixin() || this.isQQ()) {
          // this.$refs.opensf.show()
          this.openSafariShow = true
        } else {
          window.location.href = 'http://baidu.com'
        }
      }
    },

    isIPhone () {
      return this.ua_match(/iPhone/i, 'iphone')
    },

    isWeixin () {
      return this.ua_match(/MicroMessenger/i, 'micromessenger')
    },

    isQQ () {
      return this.ua_match(/QQ\//i, 'qq/')
    },

    isAndroid () {
      return this.ua_match(/Android/i, 'android')
    },

    isSafari () {
      return this.ua_match(/Safari/i, 'safari')
    },

    ua_match (re, phrase) {
      // re: UA中的正则关键词, phrase: 最终匹配出的短语
      let matches = this.agent.match(re)
      if (matches && matches[0] === phrase) {
        return true
      }
      return false
    }
  }
}
</script>
